<template>
  <div class="col-12 col-sm-12 col-md-6 col-lg-4">
    <div class="card m-2">
      <div class="card-header">
        <h5> {{ itemDetail.name }}</h5>
      </div>
      <div class="card-body">
        <p><strong>Materiál:</strong> {{ itemName }} </p>
        <p><strong>Tvar:</strong> {{ itemDetail.itemOrigin.shape.name }} </p>
        <p><strong>Rozměry [mm]: </strong> {{ itemDimensions }} </p>
        <p><strong>Síla:</strong> {{ itemDetail.itemOrigin.price_list_item.thickness.name }}</p>
        <p><strong>Váha:</strong> {{ itemDetail.weight }} Kg</p>
        <p><strong>Plocha:</strong> {{ itemDetail.area }} m<sup>2</sup></p>
        <p><strong>Cena materiálu (ceník):</strong> {{ materialPrice }} Kč/m<sup>2</sup></p>
        <p><strong>Cena materiálu (cenové skupiny):</strong> {{!isAbsolutePrice ?  materialPriceSwitched : '-'}}&nbsp;Kč/m<sup>2</sup></p>
      </div>
      <div class="card-footer">
        <a class="btn btn-primary mx-1" role="button" @click="editItem">Editovat</a>
        <a class="btn btn-warning mx-1" role="button" @click="copyItem">Vytvoř kopii</a>
        <a class="btn btn-danger mx-1" role="button" @click="deleteItem">Smaž</a>
      </div>
    </div>
  </div>
</template>

<script setup>
import router from "@/router";
import {computed, defineProps, defineEmits, ref, onMounted} from 'vue'
import {useStore} from 'vuex'
import myApi from "@/api/api";

const store = useStore()
const props = defineProps(['itemDetail'])
const emit = defineEmits(['item-update'])

const itemName = computed(() => {
  return `${props.itemDetail.itemOrigin.price_list_item.name},
      ${props.itemDetail.itemOrigin.price_list_item.surface}`
})

// vytvoření textu rozměrů, pouze pro editovatelné hrany
const itemDimensions = computed(() => {
  const dimensionText = Object.entries(props.itemDetail.dimensions)
    .filter(([key]) => props.itemDetail.itemOrigin.shape.sides[key])
    .map(([key, value]) => `${key.toUpperCase()}: ${value}`)
    .join(', ');
  return dimensionText;
})

const isAbsolutePrice = computed(() => {
  const pli = props.itemDetail.itemOrigin.price_list_item
  return pli.rate_absolute !== null && pli.rate_absolute !== 0
})

const materialPrice = ref(null)
const materialPriceSwitched = ref(null)

const fetchMaterialPrice = async (priceType) => {
  if (!isAbsolutePrice.value) {
    const response = await myApi.getMaterialPrice(props.itemDetail.itemOrigin.price_list_item.id, priceType)
    return formatCzech(response)
  }
}

const formatCzech = (num) => {
    return num.toLocaleString('cs-CZ', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}

const editItem = () => {
  let calculation = store.getters['calculation/getCalculation']
  store.dispatch({type: 'calculation/updateCalculation', payload: calculation, showNotification: false})
      .then(() => {
        router.push({
          name: 'calculationItemEdit',
          query: {cid: props.itemDetail.calculationUid, item: props.itemDetail.id, update: true}
        })
      })
}

const copyItem = () => {
  let calculation = store.getters['calculation/getCalculation']
  store.dispatch({type: 'calculation/updateCalculation', payload: calculation, showNotification: false})
      .then(() => {
        store.dispatch('items/copyItem', {item: props.itemDetail.id})
            .then(() => emit('item-update'))
      })
}

const deleteItem = () => {
  let calculation = store.getters['calculation/getCalculation']
  store.dispatch({type: 'calculation/updateCalculation', payload: calculation, showNotification: false})
      .then(() => {
        store.dispatch('items/deleteItem', {item: props.itemDetail.id})
            .then(() => emit('item-update'))
      })
  // store.dispatch('calculation/setCalculationById', props.itemDetail.calculation_uid)
}

onMounted(async () => {
  materialPrice.value = await fetchMaterialPrice(0)
  materialPriceSwitched.value = await fetchMaterialPrice(1)
})

</script>

<style scoped>
.myCartMargin {
  margin: .5em;
}
</style>

